import script from "./CornerFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./CornerFrame.vue?vue&type=script&setup=true&lang=js"

import "./CornerFrame.vue?vue&type=style&index=0&id=4aa8226f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aa8226f"]])

export default __exports__